import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-prepare-to-connect-tab',
  templateUrl: './prepare-to-connect-tab.component.html',
  styleUrl: './prepare-to-connect-tab.component.scss',
  standalone: false
})
export class PrepareToConnectTabComponent {
  @Input()
  kids = false;
}
